document.addEventListener("DOMContentLoaded", function () {
  const lastCollection = localStorage.getItem('lastCollection');

  const observer = new MutationObserver(() => {
    document.querySelectorAll('.modal--quick-shop.modal--is-active').forEach(modal => {
      modal.querySelectorAll('.product__quantity label').forEach(label => {
        const labelText = label.innerText.trim().toLowerCase();

        // Only change if label is "quantity" and collection is not the target one
        if (labelText === 'quantity' && lastCollection === 'build-personalised-corporate-gifts') {
          console.log('✅ Changing label to "Quantity per pack"');
          label.innerText = 'Quantity per pack';
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
